<template>
  <div class="modal" :style="modalCustom">
    <div class="modal-content" :style="modalContentCustom">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "modalComponent",
  props: ["modalCustom", "modalContentCustom"],  
};
</script>

<style>
.modal {
  position: fixed;
  display: flex !important;
  justify-content: center;
  align-items: center;
  z-index: 11 !important;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}
/* Conteúdo do Modal */
.modal-content {
  max-width: 600px;
  min-width: 250px;
  /* padding: 10px; */
  margin: 10% 5%;
  background-color: #fefefe;
  border: 1px solid #888;
  border-radius: 8px;
}
/* Botão de fechar modal */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: 200;
}
.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>
